import { Booking, BookingCompressed, UserTypeEnum } from '@jooxter/api';
import { fromISO, now } from '@jooxter/utils';
import { DateTime } from 'luxon';

// Admins and managers may still correct the start of a booking that is already running.
export const canEditStartedBookingStart = (userType?: UserTypeEnum): boolean =>
  userType === UserTypeEnum.Admin || userType === UserTypeEnum.Manager;

/**
 * A plain user cannot move the start of a booking that is in progress (ND-6366): it would rewrite
 * a past that already happened. Only the end stays editable.
 */
export const isBookingStartLocked = (
  booking: Pick<Booking | BookingCompressed, 'start' | 'end'> | null | undefined,
  userType?: UserTypeEnum,
  at: DateTime = now()
): boolean => {
  if (!booking || canEditStartedBookingStart(userType)) {
    return false;
  }

  return fromISO(booking.start.dateTime) <= at && at < fromISO(booking.end.dateTime);
};
